// AdminLogin.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "./SuperbaseClient";
// import logo from "../../images/header/carLogo.png";
import logo from "../../images/footer/footerLogo.png";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [err, setErr] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    console.log("data:", email, password);

    try {
      const { data, error } = await supabase
        .from("carzen_admin")
        .select("id, email")
        .eq("email", email)
        .eq("password", password)
        .limit(1)
        .single();

      if (error) {
        setErr(error.message);
        setLoading(false);
        return;
      }

      if (!data || data.length === 0) {
        setErr("Invalid credentials");
        setLoading(false);
        return;
      }

      // SUCCESS → save admin session + redirect
      localStorage.setItem("admin_email", email);
      localStorage.setItem("admin_password", password);
      localStorage.setItem("adminAuth", "true");

      navigate("/dashboard");
    } catch (e) {
      setErr("Network error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen  flex justify-center items-center ">
      <div className="bg-white p-4 md:p-8 rounded-xl shadow-md w-full max-w-md">
        <div>
          <img
            src={logo}
            className="w-32 content-center object-contain"
            alt="Logo"
          />
        </div>
        <h2 className="text-xl font-semibold text-center mb-6">Admin Login</h2>

        <form onSubmit={handleLogin} className="space-y-4 md:space-y-9">
          <input
            type="email"
            required
            placeholder="Admin Email"
            className="w-full border px-4 py-2 rounded"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {/* <input
            type="password"
            required
            placeholder="Password"
            className="w-full border px-4 py-2 rounded"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          /> */}
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              required
              placeholder="Password"
              className="w-full border px-4 py-2 rounded pr-12"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
            >
              {showPassword ? (
                /* 👁️ Eye OFF */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-5.52 0-10-4.48-10-10 0-2.05.62-3.95 1.68-5.54" />
                  <path d="M1 1l22 22" />
                  <path d="M9.53 9.53a3.5 3.5 0 0 0 4.95 4.95" />
                  <path d="M14.47 14.47a3.5 3.5 0 0 0-4.95-4.95" />
                </svg>
              ) : (
                /* 👁️ Eye ON */
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              )}
            </button>
          </div>

          {err && <p className="text-red-500 text-sm">{err}</p>}

          <button
            disabled={loading}
            className="w-full bg-[#CCA065] text-white  py-2 rounded "
          >
            {loading ? "Checking..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
